const getTime = time => (time < 10 ? '0' : '') + time;

export const DATE_FORMAT = 'DD.MM.YYYY';
export const API_DATE_FORMAT = 'YYYY-MM-DD';

export const DATE_REGEX = /\d{4}-\d{2}-\d{2}/i;

const isToday = date => {
  const today = new Date();

  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
};

const getDate = (date, withToday = false) => {
  const dateobj = new Date(date);

  const monthNames = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октабря',
    'ноября',
    'декабря'
  ];
  const [month, day, year] = [
    monthNames[dateobj.getMonth()],
    dateobj.getDate(),
    dateobj.getFullYear()
  ];
  const [hour, minutes] = [
    getTime(dateobj.getHours()),
    getTime(dateobj.getMinutes())
  ];

  const dateOnly =
    withToday && isToday(dateobj) ? 'сегодня' : `${day} ${month} ${year}`;

  return `${dateOnly} в ${hour}:${minutes}`;
};

const formatDateToISOString = date => {
  const dateObject = new Date(date);

  if (!(dateObject instanceof Date) || Number.isNaN(dateObject.getTime())) {
    return date;
  }

  const ISODateString = new Date(
    dateObject.getTime() - dateObject.getTimezoneOffset() * 60000
  ).toISOString();

  return ISODateString.slice(0, ISODateString.indexOf('T'));
};

export const formatDateStringToISOString = date => {
  let result; // YYYY-MM-DD

  if (typeof date === 'string') {
    const dateParts = date.split('.');

    if (dateParts.length === 3) {
      result = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
    } else {
      result = formatDateToISOString(date);
    }
  } else {
    result = formatDateToISOString(date);
  }

  return result;
};

export const isValidDate = date => {
  const isDateValid = date instanceof Date && !Number.isNaN(date.getTime());

  if (!isDateValid && !Number.isNaN(Number(date))) {
    return false;
  }

  const dateISOString = formatDateStringToISOString(date);
  const dateObject = new Date(dateISOString);

  return dateObject instanceof Date && !Number.isNaN(dateObject.getTime());
};

export const sortDates = dates => {
  if (!dates) {
    return null;
  }

  return dates.sort((a, b) => {
    const dateA = new Date(a);
    const dateB = new Date(b);

    if (!isValidDate(dateA)) {
      return 1;
    }

    if (!isValidDate(dateB)) {
      return -1;
    }

    return dateA.getTime() - dateB.getTime();
  });
};

export default getDate;
